Library.cmp =  {

	props: ['value'],

	data : function() {
		return {
			"folder": {},
			"subs": [],
			"files": [],
			"visible": false,
			"mode": 'list',
			"selected": {},
			"page": 0,
			"totalpages": 0,
			"total": 0,
			"idx": 0,
			"assets_path": "/html5/assets/",
			"settings": {'text': {"color": "#ffffff", "size": "14"}, "gallery": {"alpha": 1}},
			"lang": {"opendocument": "test"},
		};
	},

	mounted: function() {
		if (player.offline) {
			try {
	 			var remote = window.require('electron').remote;
	    		Library.appPath = remote.app.getAppPath();
	    		Library.shell = window.require('electron').shell;
    		} catch(e) {    			
    		}
		}
	},

	methods: {

		openDoc: function(event, path) {
			if (player.offline && Library.shell != undefined) {
				Library.shell.openItem(Library.appPath + path);

				event.stopPropagation();
				event.preventDefault();
				return false;
			}
		},

		open: function(id) {
			var self = this;

			this.lang.opendocument = TPL.lng("open.document", "Otwórz dokument");

			this.visible = true;
			this.id = id;
			this.fromCsv = false;
			console.log(id.substr(-1));
			if (id.substr(-1) == "/") this.fromCsv = true;

			this.openFolder(id);
		},

		CSVtoArray: function(text) {
		    var re_valid = /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/;
		    var re_value = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;
		    // Return NULL if input string is not well formed CSV string.
//		    console.log(text);
//		    text = text.replaceAll('""', "”");
		    text = text.replace(/""/g, "”");
//		    console.log(text);
		    if (!re_valid.test(text)) {
		    //	console.log(text);
		    	return null;
		    }
		    var a = [];                     // Initialize array to receive values.
		    text.replace(re_value, // "Walk" the string using replace with callback.
		        function(m0, m1, m2, m3) {
		            // Remove backslash from \' in single quoted values.
		            if      (m1 !== undefined) a.push(m1.replace(/\\'/g, "'"));
		            // Remove backslash from \" in double quoted values.
		            else if (m2 !== undefined) a.push(m2.replace(/\\"/g, '"'));
		            else if (m3 !== undefined) a.push(m3);
		            return ''; // Return empty string.
		        });
		    // Handle special case of empty last value.
		    if (/,\s*$/.test(text)) a.push('');
		    return a;
		},

		openFolder: function(id, pinc) {
			var self = this;

			if (pinc != undefined) {
				this.page = parseInt(this.page) + pinc;
			} else {
				this.page = 0;
			}

			if (!this.fromCsv) {
				Library.ssi("userfiles","folder",{"folder":id, "page": this.page},function(resp) {				
					//console.log(resp.data);
					self.folder = resp.data.folder;
					self.subs = resp.data.subs;
					self.files = resp.data.files;
					self.page = resp.data.page;
					self.total = resp.data.total;
					self.totalpages = resp.data.totalpages;

					var no = self.page * 50;
					for(var f in self.files) {
						no ++;
						self.$set(self.files[f], "no", no);
						self.$set(self.files[f], "thumbUrl", self.previewUrl(self.files[f]));
						self.$set(self.files[f], "previewUrl", self.previewUrl(self.files[f]));
					}
				});
			} else {
				if (player.offline) {
					self.dir = "./storage/library/" + id;
					self.assets_path = "./assets/";
				} else {
					self.dir = "/storage/library/" + id;
				}

				$.getJSON(self.dir + "index.json?ts=" + Date.now(), function(result) {
					if (player.lang == "EN" && result.title_EN != undefined) {
						self.$set(self.folder, "title", result.title_EN);
					} else {self.$set(self.folder, "title", result.title);}
					if (result.bg != undefined) {
						result.bg.file = self.dir + result.bg.file + "?ts=" + Date.now();
						result.bg.alpha = result.bg.alpha;
						self.$set(self.folder, "bg", result.bg);
					}
					self.settings = result;
				});

				$.ajax(self.dir + "index.csv?ts=" + Date.now()).done(function(result) {
					//console.log(result);
					//var lines = self.CSVtoArray(result);
					//console.log(lines);
					var lines = result.split("\n");
					self.page = 0;
					self.totalpages = 1;
					self.total = lines.length;
					self.files = [];

					for(var n in lines) {
						if (n == 0) continue;

						var cell = self.CSVtoArray(lines[n]);//.split(",");
						//console.log(cell);
						//console.log(self.dir + cell[1]);
						try {
							var type = "";
							switch (cell[0]) {
								case "audio":
									type = "audio";
									break;

								case "dokument":
									type = "document";
									break;

								default: type = "image";
							};

							//console.log(self.dir + cell[1]);

							var cell_title = 2;
							var cell_desc = 3;
							if (player.lang == "EN") {
								cell_title = 4;
								cell_desc = 5;
							}

							if (player.offline) {
								self.files.push({
									"type": type,
									"no": parseInt(n),
									"thumbUrl": self.dir + cell[1],
									"previewUrl": self.dir + cell[1] + "?ts=" + Date.now(),
									"realUrl": self.dir + cell[1],
									"title": cell[cell_title],
									"desc": cell[cell_desc]
								});
							} else {
								self.files.push({
									"type": type,
									"no": parseInt(n),
									"thumbUrl": "/thumbpreview.php?preset=library&path=" + self.dir.substring(1) + cell[1] + "&ts=" + Date.now(),
									"previewUrl": self.dir + cell[1] + "?ts=" + Date.now(),
									"realUrl": self.dir + cell[1],
									"title": cell[cell_title],
									"desc": cell[cell_desc]
								});
							}
						} catch(e) {
							console.log("Line " + n + ": " + lines[n]);
							console.log(e);
						}
					}
				});
			}
		},

		previewUrl: function(f) {
			if (player.offline)
				return "./storage/library/" + this.folder.customer_id + "/" + this.folder.path + "/" + f.filename;
			else
				return "/storage/library/" + this.folder.customer_id + "/" + this.folder.path + "/" + f.filename;
		},

		preview: function(idx) {
			this.mode = 'preview';
			this.selected = this.files[idx];
			this.idx = parseInt(idx);
		},

		closePreview: function() {
			this.mode = 'list';
		},

		close: function() {
			this.visible = false;
		}
	},

	watch: {
	},

	template: '#tpl-lib'
};